export enum ApproveHurdleColumn {
  APPROVAL_DATE = 'approval-date',
  CURRENT_VALUATION = 'current-valuation',
  GRANT = 'grant',
  HURDLE = 'hurdle',
  ISSUED_SHARES = 'issued-shares',
  SELECT = 'select',
  SHARE_CLASS = 'share-class',
  STAKEHOLDER = 'stakeholder',
}

export const approveHurdleColumnMap = Object.values(ApproveHurdleColumn);
